import AbstractTransfer from './AbstractTransfer';
export default AbstractTransfer;
//# sourceMappingURL=index.js.map
